export default __webpack_public_path__ + "static/media/vitalik_badge_2.d5d25c6c.svg";